"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commercialInvoiceMoneyMapping = exports.CommercialInvoiceStatus = void 0;
var CommercialInvoiceStatus;
(function (CommercialInvoiceStatus) {
    CommercialInvoiceStatus["BACKLOG"] = "backlog";
    CommercialInvoiceStatus["PRINTED"] = "printed";
})(CommercialInvoiceStatus = exports.CommercialInvoiceStatus || (exports.CommercialInvoiceStatus = {}));
exports.commercialInvoiceMoneyMapping = {
    totalAmount: "totalAmountScaled",
};
